import { render, staticRenderFns } from "./_base-small-spinner.vue?vue&type=template&id=39cd98d6&scoped=true"
var script = {}
import style0 from "./_base-small-spinner.vue?vue&type=style&index=0&id=39cd98d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cd98d6",
  null
  
)

export default component.exports